import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

/**
 * Custom async validators for the dynamic form system
 */

/**
 * Username availability validator (example)
 * In real implementation, this would call an API
 */
export function usernameAvailableValidator(params?: any): AsyncValidatorFn {
  const debounceMs = params?.debounceMs || 500;

  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null);
    }

    return timer(debounceMs).pipe(
      switchMap(() => {
        // In real implementation, this would be an HTTP call
        // For now, simulate API call
        return of({ available: Math.random() > 0.3 });
      }),
      map(response => {
        return response.available ? null : { usernameAvailable: true };
      }),
      catchError(() => of(null))
    );
  };
}

/**
 * Email availability validator (example)
 */
export function emailAvailableValidator(params?: any): AsyncValidatorFn {
  const debounceMs = params?.debounceMs || 500;

  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value) {
      return of(null);
    }

    return timer(debounceMs).pipe(
      switchMap(() => {
        // Simulate API call
        return of({ available: Math.random() > 0.3 });
      }),
      map(response => {
        return response.available ? null : { emailAvailable: true };
      }),
      catchError(() => of(null))
    );
  };
}

/**
 * Custom API validator factory
 * Allows calling any API endpoint for validation
 */
export function apiValidator(params?: any): AsyncValidatorFn {
  const debounceMs = params?.debounceMs || 500;
  const apiUrl = params?.apiUrl;
  const validationKey = params?.validationKey || 'apiValidation';

  return (control: AbstractControl): Observable<ValidationErrors | null> => {
    if (!control.value || !apiUrl) {
      return of(null);
    }

    return timer(debounceMs).pipe(
      switchMap(() => {
        // In real implementation, use HttpClient
        // For now, return mock response
        return of({ valid: true });
      }),
      map(response => {
        return response.valid ? null : { [validationKey]: true };
      }),
      catchError(() => of(null))
    );
  };
}
